<template>
  <div class="page-batch-ai flex flex-column">
    <header>
      <div class="title">AI批量岗位生成</div>
      <div class="t-info flex">
        <span>1.上传招聘信息文件</span>
        <span class="arrow" />
        <span>2.AI识别并批量生成岗位信息</span>
        <span class="arrow" />
        <span>3.确认信息并保存</span>
      </div>
    </header>

    <body class="body">
      <div class="tip"><i class="el-icon-warning" />AI识别生成内容或有偏差，内容基本正确的岗位可先选中保存至待发布岗位管理后进行修改微调，并批量上架</div>
      <div class="btns-operate">
        <div class="lef flex">
          <el-button @click="handleSelectAll">全选</el-button>
          <el-button @click="handleInvertSelect">反选</el-button>
          <el-button @click="handleBack">返回上一步</el-button>
        </div>
        <div class="rig flex">
          <span class="sel-t">{{ `已选择${selectRows.length}项` }}</span>
          <el-button @click="handleClearAll">清除</el-button>
          <el-button class="l-c" :disabled="!selectRows.length" @click="handleSubmit">保存到待发布</el-button>
        </div>
      </div>
      <el-table ref="multipleTable" :data="list" style="width: 100%" @selection-change="handleSelectionChange"
        >
        <el-table-column type="selection" width="55" fixed="left">
        </el-table-column>
        <template v-for="item in columns">
          <el-table-column :prop="item.props" :label="item.label" show-overflow-tooltip width="120">
          </el-table-column>
        </template>
        <el-table-column
          fixed="right"
          label="操作"
          width="120">
          <template slot-scope="scope">
            <el-button
              class="btn-del"
              @click.native.prevent="deleteRow(scope.$index, list)"
              type="text"
              size="small"
              >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

    </body>

    <el-dialog v-model="visibleSubmit">
      <div class="sub-dialog">
        <div class="title">批量生成岗位 <font class="col">已保存</font> </div>
        <div class="content">{{`${selectRows.length}条选中的生成的岗位信息以保存为待发布岗位，您可以移步至待发岗位列表查看编辑。为了保障您与求职者的招聘体验，请仔细检查调整岗位信息后发布。`}}</div>
        
        <div class="btn-di">
          <el-button @click="visibleSubmit = false">好的</el-button>
          <el-button class="l-c" @click="jump">查看待发布岗位列表</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const columns = [
  { props: 'title', label: '岗位名称' },
  { props: 'industryName', label: '岗位类别' },
  { props: 'description', label: '职位描述' },
  { props: 'recruitNumber', label: '招聘人数' },
  { props: 'requireSexCN', label: '性别要求' },
  { props: 'requireEduCN', label: '学历要求' },
  { props: 'workTimeCN', label: '工作时间' },
  { props: 'welfareCN', label: '福利待遇' },
  { props: 'provideBedroomCN', label: '住宿' },
  { props: 'provideDiningroomCN', label: '用餐方式' },
]


export default {
  components: {},
  data() {
    return {
      columns,
      visibleSubmit: false,
      list: [],
      selectRows: []
    }
  },
  methods: {
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    handleSelectionChange(selection) {
      console.log('selection', selection)
      this.selectRows = selection
    },
    handleSelectAll() {
      this.list.forEach(row => {
        this.$refs.multipleTable.toggleRowSelection(row, true)
      })
    },
    handleInvertSelect() {
      this.list.forEach(row => {
        this.$refs.multipleTable.toggleRowSelection(row)
      })
    },
    handleClearAll() {
      this.list = this.list.filter(row => !this.selectRows.some(itemB => itemB.idCN === row.idCN))
    }, 
    handleSubmit() {
      const _list = this.selectRows.map(obj => {
        let entries = Object.entries(obj);
        
        let filteredEntries = entries.filter(([key, value]) => !key.includes("CN"));
        
        return Object.fromEntries(filteredEntries);
      })
      console.log('_list--', _list)

      this.$confirm('确认将所选岗位发布到平台吗？','',{
            confirmButtonText: '是的',
            cancelButtonText:"取消"
        }).then(()=>{
          this.axios.post('/wapi/hr/recruit/cSaveBatch', {
            recruitList: _list
          }).then(res => {
            if (res.status === 200) {
              // this.$message.success('发布成功')
              this.visibleSubmit = true
              // setTimeout(() => {
              //   this.$router.push('/index/posts/list')
              // }, 1.5 * 1000)
            } else {
              this.$message.error(res.msg || '发布析失败，请重试～')
            }
          }).catch(err => {
            this.$message.error(err || '发布失败，请重试');
          })
        })
    },
    handleBack() {
      this.$router.push({
        path: "/index/posts",
        query: { openAiUpload: true }
      })
    },
    jump() {
      this.$router.push({
        path: "/index/posts",
        query: { tabindex: '2' }
      })
    },
    _forSex(val) {
      switch (val) {
        case 1:
          return '男性'
        case 2:
          return '女性'
        default:
          return '不限'
      }
    },
    _forEdu(val) {
      switch (val) {
        case 1:
          return '初中及以下'
        case 2:
          return '高中/中专/中技'
        case 4:
          return '大专'
        case 8:
          return '本科'
        case 16:
          return '硕士'
        case 32:
          return '博士'
        default:
          return '不限'
      }
    },
    _forTime(sTime, eTime) {
      return `${sTime.substr(0, 5)} - ${eTime.substr(0, 5)}`
    },
    _forBed(val) {
      switch (val) {
        case 1:
          return '提供宿舍'
        case 0:
          return '自行安排'
        default:
          return '自行安排'
      }
    },
    _forDin(val) {
      switch (val) {
        case 1:
          return '食堂用餐'
        case 0:
          return '自行安排'
        default:
          return '自行安排'
      }
    }
  },
  mounted() {
    console.log('list--', JSON.parse(this.$store.getters.getAiBatchData))
    this.list = JSON.parse(this.$store.getters.getAiBatchData).map((f, index) => ({
      ...f,
      requireSexCN: this._forSex(f.requireSex),
      requireEduCN: this._forEdu(f.requireEdu),
      workTimeCN: this._forTime(f.workStartTime, f.workEndTime),
      welfareCN: f.welfare.join(','),
      provideBedroomCN: this._forBed(f.provideBedroom),
      provideDiningroomCN: this._forDin(f.provideDiningroom),
      idCN: index
    }))
    
  }
}
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}

.page-batch-ai {
  height: 100%;

  header {
    width: 100%;
    height: 118px;
    background: #FFFFFF;
    border-radius: 8px;
    margin-bottom: 12px;
    padding: 27px 24px 0 24px;

    .title {
      font-weight: bold;
      font-size: 22px;
      color: #141414;
      line-height: 30px;
      margin-bottom: 10px;
    }

    .t-info {
      font-size: 15px;
      color: #0984FA;
      line-height: 20px;
      font-size: 15px;
      color: #0984FA;

      .arrow {
        display: inline-block;
        width: 54px;
        height: 10px;
        margin: 0 30px;
        background: url('~@/assets/images/index/icon_arrow_ai.png')no-repeat center/100% 100%;
      }
    }
  }

  .body {
    width: 100%;
    flex: 1;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 20px;

    .tip {
      height: 46px;
      line-height: 46px;
      background: #FFF7E8;
      border-radius: 4px;
      color: rgba(78, 89, 105, 1);
      font-size: 14px;
      margin-bottom: 16px;
      padding-left: 16px;
      .el-icon-warning {
        color: rgba(255, 125, 0, 1);
        margin-right: 9px;
      }
    }

    .btns-operate {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;

      .sel-t {
        margin-right: 10px;
      }

      .l-c {
        color: #ffffff;
        background: linear-gradient(90deg, #057CF9 0%, #1AAFFD 100%);
      }
    }
  }
  .btn-del {
    color: red;
  }
  /deep/ .el-table th {
    background-color: rgba(250, 250, 250, 1);
    .cell {
      background-color: rgba(250, 250, 250, 1);
      color: rgba(78, 89, 105, 1);
    }
  }

  /deep/ .el-dialog{
    width: 600px;
    background: linear-gradient(166deg, rgb(199, 227, 225) 5%, #ffffff);
    .el-dialog__body {
      padding-top: 0;
    }
    .title {
      font-weight: bold;
      font-size: 24px;
      color: #000000;
      line-height: 33px;
      margin-bottom: 14px;
      .col {
        color: rgba(5, 125, 249, 1);
      }
    }
    .content {
      font-weight: 400;
      font-size: 16px;
      color: rgba(142, 143, 146, 1);
      line-height: 27px;
      text-align: left;
      font-style: normal;
      margin-bottom: 23px;
    }
    .btn-di {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .l-c {
        color: #ffffff;
        background: linear-gradient(90deg, #057CF9 0%, #1AAFFD 100%);
      }
    }
  }
  .el-button.is-disabled {
    color: #bfcbd9 !important;
    background-image: none !important;
    background-color: #eef1f6 !important;
  }
}
</style>


// WEBPACK FOOTER //
// btachAi.vue?ad421c90